import { render, staticRenderFns } from "./BalanceOut.vue?vue&type=template&id=bafa6bba&scoped=true"
import script from "./BalanceOut.vue?vue&type=script&lang=js"
export * from "./BalanceOut.vue?vue&type=script&lang=js"
import style0 from "./BalanceOut.vue?vue&type=style&index=0&id=bafa6bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafa6bba",
  null
  
)

export default component.exports